export default () => {
  // Get all select elements and store them in an array
  const filterSelects = [...document.querySelectorAll('.js-panel-filters-select')];

  // Get all panel items
  const panelItems = document.querySelectorAll('.js-panel-item');

  // Filter items
  const filterItems = () => {
    const selectedValues = filterSelects.map((select) => select.value);

    panelItems.forEach((item) => {
      const itemData = {
        store: item.getAttribute('data-store'),
        position: item.getAttribute('data-position'),
        contract: item.getAttribute('data-contract'),
      };

      const isMatch = filterSelects.every((select, index) => {
        const selectedValue = selectedValues[index];
        const selectName = select.getAttribute('name');
        const itemAttributeValue = itemData[selectName];

        const isValueMatching = selectedValue === '' || selectedValue === itemAttributeValue;
        return isValueMatching;
      });

      item.style.display = isMatch ? 'block' : 'none';
    });
  };

  // Add event listeners to each select element
  filterSelects.forEach((select) => {
    select.addEventListener('change', filterItems);
  });
};
